module.exports = __webpack_public_path__ + "static/img/app-2.d66cf0bc.png";